import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Container,
  Divider,
  Link
} from '@mui/material';
import { useAuth } from '../context/AuthContext.tsx';
import { useNavigate } from 'react-router-dom';
import ThuisverpleegLogo from '../components/ThuisverpleegLogo.tsx';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, loading } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Inloggen - Thuisverpleging Portaal';
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      await login(email, password);
      navigate('/home');
    } catch (err: any) {
      setError(err.message || "Er ging iets mis bij inloggen");
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4
        }}
      >
        <Card sx={{ width: '100%', maxWidth: 400 }}>
          <CardContent sx={{ p: 4 }}>

            {/* HEADER */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <ThuisverpleegLogo width={64} height={64} />
              <Typography variant="h4" sx={{ mt: 2 }}>
                Thuisverpleging
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                Portaal voor Zorgverleners
              </Typography>
            </Box>

            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="E-mailadres"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                margin="normal"
                variant="outlined"
              />

              <TextField
                fullWidth
                label="Wachtwoord"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                margin="normal"
                variant="outlined"
              />

              {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {error}
                </Alert>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                disabled={loading}
                sx={{ mt: 3, py: 1.5 }}
              >
                {loading ? <CircularProgress size={24} /> : 'Inloggen'}
              </Button>
            </form>

            {/* FOOTER */}
            <Box sx={{ textAlign: 'center', mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
              <Link
                href="/wachtwoord-vergeten"
                variant="body2"
                sx={{
                  color: 'primary.main',
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Wachtwoord vergeten?
              </Link>
            </Box>

          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default LoginPage;
